export default {
  '学年学期管理':'學年學期管理',
  '至':'至',
  '新增学年':'新增學年',
  '秋季学期':'秋季學期',
  '春季学期':'春季學期',
  '寒假':'寒假',
  '暑假':'暑假',
  '是否删除{year}学年学期？':'是否刪除{year}學年學期？',
  '编辑学年':'編輯學年',
  '学期时间':'學期時間',
  '入学年份管理':'入學年份管理',
  '学段':'學段',
  '毕业状态':'畢業狀態',
  '当前年级':'當前年級',
  '入学年份':'入學年份',
  '新增入学年份':'新增入學年份',
  '编辑入学年份':'編輯入學年份',
  '是否删除{gradeName}？':'是否刪除{gradeName}？',
  '入学年份删除成功':'入學年份刪除成功',
  '新增入学年份成功':'新增入學年份成功',
  '班级管理':'班級管理',
  '新增班级':'新增班級',
  '班级码':'班級碼',
  '班级导入模板':'班級導入模板',
  '批量新增班级':'批量新增班級',
  '所属学级':'所屬學級',
  '当前年级':'當前年級',
  '班级名称':'班級名稱',
  '班级编号':'班級編號',
  '班级人数':'班級人數',
  '编辑班级':'編輯班級',
  '新增班级成功':'新增班級成功',
  '编辑班级成功':'編輯班級成功',
  '是否批量删除所选班级？':'是否批量刪除所選班級？',
  '请勾选要删除的班级':'請勾選要刪除的班級',
  '是否删除班级{classFullName}？':'是否刪除班級{classFullName}？',
  '导入班级时关联教师信息，可以在导入时一并创建教师角色':'導入班級時關聯教師資訊，可在導入時一併創建教師角色',
  '所属学级不能为空':'所屬學級不能為空',
  '更多班号':'更多班號',
  '班级编码':'班級編碼',
  '教师姓名':'教師姓名',
  '根据所选编号区间，批量生成班级，已有编号自动跳过':'根據所選編號區間，批量生成班級，已有編號自動跳過',
  '新增年级':'新增年級',
  '班级编码不能为空':'班級編碼不能為空',
  '班级编码范围有误':'班級編碼範圍有誤',
  '班级编码不超过99':'班級編碼不超過99',
  '班级导出':'班級導出',
  '院系导出':'院系導出',
  '专业导出':'專業導出',
  '机构列表':'機構列表',
  '请输入机构名\机构代码':'請輸入機構名\機構代碼',
  '新增机构':'新增機構',
  '设备激活码':'設備激活碼',
  '重置激活码':'重置激活碼',
  '可激活设备数量':'可激活設備數量',
  '已激活设备':'已激活設備',
  '机构名称':'機構名稱',
  '机构代码':'機構代碼',
  '上级机构':'上級機構',
  '系统管理员':'系統管理員',
  '确认要删除该机构：{orgName}？':'確認要刪除該機構：{orgName}？',
  '可激活数量必须大于已激活数量。':'可激活數量必須大於已激活數量。',
  '上级机构名称':'上級機構名稱',
  '管理员密码':'管理員密碼',
  '编辑机构':'編輯機構',
  '密码不能少于6位':'密碼不能少於6位',
  '密码不能多于20位':'密碼不能多於20位',
  '系统管理员{newVal}':'系統管理員{newVal}',
  '院系':'院系',
  '专业':'專業',
  '根据班级名称模糊查询':'根據班級名稱模糊查詢',
  '批量添加':'批量添加',
  '院系管理':'院系管理',
  '根据名称或代码搜索':'根據名稱或代碼搜索',
  '批量新增院系':'批量新增院系',
  '院系名称':'院系名稱',
  '院系代码':'院系代碼',
  '上级组织':'上級組織',
  '编辑院系':'編輯院系',
  '请输入两位数字代码':'請輸入兩位數字代碼',
  '新增院系':'新增院系',
  '专业管理':'專業管理',
  '根据专业、院系名称或代码搜索':'根據專業、院系名稱或代碼搜索',
  '批量新增专业':'批量新增專業',
  '专业名称':'專業名稱',
  '专业代码':'專業代碼',
  '所属院系':'所屬院系',
  '所属院系代码':'所屬院系代碼',
  '学制':'學制',
  '请选择修学年限':'請選擇修學年限',
  '新增专业':'新增專業',
  '编辑专业':'編輯專業',
  '请选择添加范围':'請選擇添加範圍',
  '请按照模板格式进行导入，':'請按照範本格式進行導入，',
  '点击下载模板':'點擊下載範本',
  '点击或将文件拖拽到这里':'點擊或將檔案拖拽到這裡',
  '上传支持':'上傳支持',
  '上传中，请稍等':'上傳中，請稍等...',
  '创建成功':'創建成功',
  '创建失败':'創建失敗',
  '导出失败记录':'匯出失敗記錄',
  '部分数据创建失败，请导出失败记录，修改后重新上传。':'部分數據創建失敗，請匯出失敗記錄，修改後重新上傳。',
}    